<template>
  <v-sheet :color="color" class="plannings-task-event" tile>
    <p class="plannings-task-event__item">
      {{ time }}
    </p>
    <p class="plannings-task-event__item">
      <strong>{{ $t('ORDERS.ITEM') }}:</strong>
      {{ orderNumber }}
    </p>
    <p class="plannings-task-event__item">
      <strong>{{ $t('ORDERS.CUSTOMER') }}:</strong>
      {{ customer }}
    </p>
    <p class="plannings-task-event__item">
      <strong>{{ $t('ITEM.ADDRESS') }}:</strong>
      {{ address }}
    </p>
    <p class="plannings-task-event__item">
      <strong>{{ $t('SERVICES.ITEM') }}:</strong>
      {{ service }}
    </p>
    <p class="plannings-task-event__item">
      <strong>{{ $t('ITEM.STATUS') }}:</strong>
      {{ status }}
    </p>
    <p class="plannings-task-event__item">
      <strong>{{ $t('ITEM.ADDITIONAL_INFO') }}:</strong>
      {{ task.info }}
    </p>
    <div class="plannings-task-event__buttons">
      <slot name="buttons">
        <v-btn color="white" depressed small @click="view">
          {{ $t('BUTTON.VIEW') }}
        </v-btn>
      </slot>
    </div>
  </v-sheet>
</template>

<script>
import task from './mixins/task';

export default {
  name: 'EventTask',

  mixins: [task],

  computed: {
    orderNumber() {
      const order = this.task.order;

      return order && order.order_number ? order.order_number : '';
    },

    customer() {
      const order = this.task.order;

      return order && order.customer ? order.customer : '';
    },

    service() {
      const order = this.task.order;

      return (
        (order &&
          order.service &&
          order.service.translation &&
          order.service.translation.name) ||
        ''
      );
    },

    address() {
      const order = this.task.order;

      if (!order) {
        return '';
      }

      const street = order.street || '';
      const zip = order.zip || '';
      const city = order.city || '';

      return `${street}, ${zip} ${city}`.replace(/^[\s,]+|[\s,]+$/g, '');
    }
  }
};
</script>

<style lang="scss">
.plannings-task-event {
  & &__item {
    display: block;
    margin-bottom: 0.5em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & &__buttons {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
